import { inject } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import * as actions from '../actions/featured-events.action';
import { switchMap, map, catchError } from 'rxjs/operators';
import { EventService } from '../../services';

export const loadFeaturedEvents$ = createEffect(
  (actions$ = inject(Actions), service = inject(EventService)) => {
    return actions$.pipe(
      ofType(actions.LoadFeaturedEvents),
      switchMap(() =>
        service.getFeaturedEvents().pipe(
          map(events => actions.LoadFeaturedEventsSuccess({ events })),
          catchError(error => of(actions.LoadFeaturedEventsFail({ error })))
        )
      )
    );
  },
  { functional: true }
);
